<template>
    <Head :title="`v${entry.version} – ${entry.title}`" />
    <div class="px-4 md:px-8">
        <div class="max-w-3xl mx-auto">
            <div class="mb-6">
                <Link
                    href="/changelog"
                    class="inline-flex items-center text-sm text-slate-500 hover:text-orange transition-colors duration-150"
                >
                    <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                    Back to Changelog
                </Link>
            </div>

            <article class="bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 overflow-hidden">
                <div class="border-t-4 border-orange"></div>
                <div class="px-8 py-8 prose dark:prose-invert max-w-none">
                    <header class="mb-6 not-prose">
                        <div class="flex flex-wrap items-center gap-2 mb-3">
                            <span
                                v-if="entry.changelog_category"
                                class="text-xs font-medium bg-sky-100 text-sky-600 rounded-full px-2.5 py-1"
                            >
                                {{ entry.changelog_category.name }}
                            </span>
                            <span class="text-xs font-semibold uppercase text-slate-400">
                                {{ entry.post_date }}
                            </span>
                        </div>
                        <h1 class="text-2xl md:text-3xl font-bold text-slate-800 dark:text-slate-100 leading-tight">
                            v{{ entry.version }} – {{ entry.title }}
                        </h1>
                    </header>
                    <div v-safe-html="entry.post_content"></div>
                </div>
            </article>
        </div>
    </div>
</template>
<script setup>
import { Head, Link } from '@inertiajs/vue3';

defineProps({
    entry: {
        type: Object,
        required: true,
    },
});
</script>
